import store from '../store';
import Notify from '../views/notify/Index.vue'
import {checkauth} from "../Helper";

export default [
    {
        path: '/notify',
        name: 'notifypage',
        component: Notify,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    // console.log(response)
                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },


]
